<template>
  <div id="app">
    <div v-if="error" class="error-popup">
      <a href="javascript:" class="error-symbol"></a>
      {{ error }}
    </div>
    <input v-model="userID" type="hidden" id="luid" />
    <transition name="fade">
      <router-view :userID="userID" :finnakies="finnakies" />
    </transition>
    <toast
      v-if="isClientOutside"
      :toggleToast="isClientOutside"
      :options="options"
      toastType="dialog"
      :action="openLineLiff"
    ></toast>
  </div>
</template>

<script>
// TODO: Create axios instance for gobal handler
import { generateUID } from "./utils/analytic"
import { mapGetters, mapActions } from "vuex"
import { openMiniAppPage } from "./utils/data-layer"
if (process.env.VUE_APP_CONFIG_VCONSOLE === "true") {
  const VConsole = require("vconsole")
  new VConsole()
}

export default {
  components: {
    Toast: () => import("../src/components/miniapp/global/Toast"),
  },
  data() {
    return {
      error: null,
      userID: null,
      finnakies: null,
      query: null,
      options: {
        dialog: {},
        isFullscreen: true,
      },
      isClientOutside: false,
    }
  },
  watch: {
    $route(to, from) {
      this.sendAnalytic(to, from)
    },
    async getLineID() {
      let un = this.$cookies.get("finnakies")
      if (!un || un == "null" || un == "undefined") {
        un = generateUID(7)
        this.$cookies.set("finnakies", un)
      }

      this.finnakies = un

      const lineID = this.lineID()
      const refreshTokenResult = await this.authRefreshToken(lineID)
      if (!(refreshTokenResult && refreshTokenResult.data && refreshTokenResult.data.success)) {
        window.location = '/login'
      }
      const rs = await this.findUserProfile()

      const userID = rs.result.userID
      await this.getBrazeExternalID(userID)

      if (process.env.NODE_ENV !== "development") {
        if (rs.success == true) {
          this.$liff.ready.then(() => {
            this.$liff
              .getProfile()
              .then((profile) => {
                const email = this.$liff.getDecodedIDToken().email || ""
                this.getLineProfile({ ...profile, email })
              })
              .catch((error) => {
                console.error("Error getting profile: " + error)
              })
          })
        }
      }
    },
  },
  computed: {
    ...mapGetters("auth", ["getIslogin", "getUser"]),
    ...mapGetters("onboarding", ["getLineID"]),
  },
  async mounted() {
    this.sendAnalytic(this.$route)

    let query = this.$route.query
    const page = query.page
    delete query.page

    if (query.display) {
      let success = this.displayExternalPage(query.display)
      if (!success) {
        this.dispatch(404, query)
      }
    }

    try {
      this.userID = await this.init(process.env.VUE_APP_LIFF_ID)
      if (page) {
        this.dispatch(page, query)
      } else {
        if (document.referrer == "") {
          this.dispatch("miniapp", query)
        }
      }
    } catch (err) {
      this.error = err.message
      this.onOpenWebBrowser()
    }
  },
  methods: {
    ...mapActions("auth", [
      "findUserProfile",
      "authRefreshToken",
      "saveLineProfile",
      "getBrazeExternalID",
    ]),
    sendAnalytic(to, from) {
      let data = {}
      data.luid = this.userID
      data.referrer = from ? from.path : document.referrer
      data.cu = to.path

      if (!to.name) {
        return
      }

      if (to.name.includes("miniapp-market-")) {
        let type = to.name.split("miniapp-market-")[1]
        data.assetType = type

        if (type == "gold") {
          if (to.query.gold_detail) {
            data.assetName = to.query.gold_detail.split("_")[1]
          }
        }
      } else if (to.name.includes("-quote")) {
        let type = to.name.split("-")[1]
        data.assetType = type
        data.assetName = to.query.name
        data.assetId = to.query.id

        // Special Case
        if (type == "fund") {
          data.fundName = to.query.name
          data.fundId = to.query.id
        } else if (type == "stock") {
          data.stockName = to.query.name
          data.stockId = to.query.id
        }
      } else if (to.name == "miniapp-tradingview") {
        data.assetName = to.query.name
        data.assetId = to.query.id
        data.assetType = to.query.type

        if (to.query.type == "fund") {
          data.fundName = to.query.name
          data.fundId = to.query.id
        } else if (to.query.type == "stock") {
          data.stockName = to.query.name
          data.stockId = to.query.id
        }
      }

      openMiniAppPage(data)
    },
    lineID() {
      return this.getLineID || ""
    },
    init: function (liffId) {
      return new Promise((resolve, reject) => {
        this.$liff.ready.then(() => {
          this.$liff
            .getProfile()
            .then((profile) => {
              resolve(profile.userId)
            })
            .catch((err) => {
              reject(err)
            })
        })
      })
    },
    dispatch: function (page, query) {
      this.$router.replace({
        name: page,
        params: {
          userID: this.userID,
          finnakies: this.finnakies,
        },
        query: query,
      })
    },
    getDomainFromURL: function (url) {
      if (url) {
        return url
          .replace("http://", "")
          .replace("https://", "")
          .split(/[/?#]/)[0]
      }

      return ""
    },
    displayExternalPage(url, query) {
      const currentDomain = this.getDomainFromURL(
        process.env.VUE_APP_FINNOMENA_URL
      )

      const domain = this.getDomainFromURL(url)

      if (domain === currentDomain) {
        window.location = url
        return true
      }

      return false
    },
    async getLineProfile(profile) {
      await this.saveLineProfile(profile)
    },
    launchVConsole() {},
    onOpenWebBrowser() {
      if (
        process.env.NODE_ENV === "production" &&
        process.env.VUE_APP_CONFIG_UNIVERSAL_LINK === "true" &&
        this.$liff.getOS() == "web"
      ) {
        if (this.$liff.isInClient() === false) {
          // is open app outside line application
          document.documentElement.style.overflow = "hidden"
          this.isClientOutside = true
          this.options.dialog.title = `ใช้บริการได้ที่ LINE บนสมาร์ทโฟนหรือแท็บเล็ต`
          this.options.dialog.body = `โปรดเปิดแอพ LINE <br> บนสมาร์ทโฟนหรือแท็บเล็ตแล้วใช้กล้องสแกนคิวอาร์โค้ดด้านล่างเพื่อใช้บริการนี้`
          this.options.valueQR = `${process.env.VUE_APP_UNIVERSAL_LINK}${window.location.pathname}${window.location.search}`
          return 1
        }
        // is open app inside line application
        document.documentElement.style.overflow = ""
        this.isClientOutside = false
      }
      this.isClientOutside = false
    },
    openLineLiff() {
      try {
        this.$liff.openWindow({
          url: process.env.VUE_APP_UNIVERSAL_LINK,
          external: true,
        })
      } catch (err) {
        window.open(process.env.VUE_APP_UNIVERSAL_LINK)
      }
    },
  },
}
</script>
<style lang="scss">
@import "/fonts/DBHeaventRez.css";
@import "/fontawesome-v5/css/all.min.css";
html {
  scroll-behavior: smooth;
}
// TODO: Solve CORS, Dynamic url
// @import url(https://scontent-qa.finnomena.com/fonts/DBHeaventRez.css)
// @import url(https://scontent-qa.finnomena.com/fontawesome-v5/css/all.min.css)
</style>
